import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Plans from "@/pages/Plans";
import Quote from "@/pages/Quote";
import SmartBag from "@/pages/SmartBag";
import Telemedicine from "@/pages/Telemedicine";
import Connectivity from "@/pages/Connectivity";
import RiskOptions from "@/pages/RiskOptions";
import TradersConferences from "@/pages/TradersConferences";
import SeasonalWorkers from "@/pages/SeasonalWorkers";
import Partners from "@/pages/Partners";
import Compliance from "@/pages/Compliance";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/smartbag" element={<SmartBag />} />
            <Route path="/telemedicine" element={<Telemedicine />} />
            <Route path="/connectivity" element={<Connectivity />} />
            <Route path="/risk-options" element={<RiskOptions />} />
            <Route path="/traders-conferences" element={<TradersConferences />} />
            <Route path="/seasonal-workers" element={<SeasonalWorkers />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#0F1626", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
    </div>
  );
}

export default App;
